import { NumericInput } from "@blueprintjs/core";
import { useContext } from "react";
import PageContext from "../Context/PageContext";
import Helper from "../Component/Helper";
import { createOneValueAndContextItinerairetAction } from "../history/itineraire.history";

//import { initFondCarte } from '../ElementConf/initFondCarte'

export default function CarteSection(props: any) {

    const { mapSources, mapLayers, mapTaille, setMapTaille, mapUrlStyle, setMapUrlStyle, mapListTrace, isMode3D,
        initFondCarte, history } = useContext(PageContext);


    function heightChange(event: number) {
        if (setMapTaille != null) setMapTaille({ height: event, width: mapTaille.width });

        const mapContainer = document.getElementsByClassName('map-element')[0] as HTMLElement;
        mapContainer.style.height = event + "px";
    }

    function widthChange(event: number) {
        if (setMapTaille != null) setMapTaille({ height: mapTaille.height, width: event });

        const mapContainer = document.getElementsByClassName('map-element')[0] as HTMLElement;
        mapContainer.style.width = event + "px";
    }


    function changeMapStyleUrl(event: any, url: string) {
        var map = (window as any).$map;

        let from = mapUrlStyle;

        console.log(url)
        map.setStyle(url);

        if (setMapUrlStyle != null) setMapUrlStyle(url)

        setTimeout(() => {
            //console.log("Delayed for 1 second.");
            //TO DO JUST AFTER
            addSourcesAndLayers();

        }, 1500);

        removeSelectedMap();

        event.currentTarget.classList.add("selected-map");

        let action = createOneValueAndContextItinerairetAction({
            target: "map-style",
            item: null,
            from,
            to: url,
            context: { setMapUrlStyle, addSourcesAndLayers, removeSelectedMap}
        });

        history.add(action);

    }

    function removeSelectedMap() {
        const selectedMap = document.getElementsByClassName('selected-map');
        if (selectedMap[0] !== undefined) selectedMap[0].classList.remove("selected-map");
    }

    //map set Style remove all sources and layers, we have to set it back
    function addSourcesAndLayers() {

        var map = (window as any).$map;

        var source = mapSources;
        var layer = mapLayers;

        //var sourceData = 

        console.log(source)
        console.log(map.getSource())

        for (let i = 0; i < source.length; i++) {

            var sourceData = mapListTrace.find((elem: any) => elem.id === source[i].id);

            map.addSource(source[i].id, {
                type: "geojson",
                data: sourceData.sourceData,

            });
            map.addLayer({
                id: layer[i].id,
                type: layer[i].type,
                source: layer[i].source,
                layout: {
                    // get the title name from the source's "title" property
                    //"text-field": ['get', 'title'],
                },
                paint: sourceData.traceStyle //layer[i].paint
            })

        }

        if (isMode3D === true) {

            map.addSource('mapbox-dem', {
                'type': 'raster-dem',
                'url': 'mapbox://mapbox.mapbox-terrain-dem-v1',
                'tileSize': 512,
                'maxzoom': 14
            });
            // add the DEM source as a terrain layer with exaggerated height
            map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': 2 });

        }
    }

    const fondCarteElement = initFondCarte.map((fondCarte: any) =>
        <FondCarteElement fond={fondCarte} key={fondCarte.id} changeMapStyleUrl={changeMapStyleUrl} isActive={mapUrlStyle === fondCarte.url ? true : false} />
    );

    return (
        <div>
            <h2> Carte de l'affiche </h2>
            <div className="texte-abs-section">Choisissez la position, la taille et la couleur de votre libellé...</div>

            <div className="subtitle-section">
                <h3 > Taille de la carte </h3>
                <Helper text="Ici, personnalise la taille de la carte sur ton affiche. Une autre option pour la modifier est disponible : en cliquant sur la carte, son contour devient bleu, te permettant également d'ajuster la taille de la carte à l'aide des flèches situées aux coins​" />
            </div>
            <div className="input-hw-map">
                <label className="label-side-menu">Hauteur</label>
                <NumericInput id="map_height" max={1920} rightElement={<div className="numeric-inout-right-text">px</div>} className="input-map-size" onValueChange={heightChange} defaultValue={mapTaille.height} value={mapTaille.height} small={true} stepSize={10} />
            </div>
            <div className="input-hw-map">
                <label className="label-side-menu">Largeur</label>
                <NumericInput id="map_width" max={1920} rightElement={<div className="numeric-inout-right-text">px</div>} onValueChange={widthChange} defaultValue={mapTaille.width} value={mapTaille.width} small={true} stepSize={10} />
            </div>

            <div className="subtitle-section">
                <h3 > Fond de carte </h3>
                <Helper text="Sélectionne parmi nos multiples fonds de carte disponibles, offrant une variété de couleurs pour satisfaire tous les goûts​​" />
            </div>

            <div className="theme-container">
                {fondCarteElement}
            </div>

        </div>
    );
}

const FondCarteElement = (props: any) => {

    const fondCarte = props.fond;
    const changeMapStyleUrl = props.changeMapStyleUrl;
    var isActive = props.isActive;

    return (
        <div id={fondCarte.id} className={"style-map " + (isActive ? "selected-map" : "")} onClick={(e) => changeMapStyleUrl(e, fondCarte.url)} >
            <img title={fondCarte.name} alt="fond" src={process.env.REACT_APP_URL_BACK + "/" + fondCarte.img} />
        </div>
    )
}